<template>
  <div class="contents">
    <h1 class="title" v-cloak>{{title}}</h1>
    <div v-html="body" class="content" v-cloak></div>
  </div>
</template>

<script>
import top from "@/components/v2/Header.vue";
export default {
  metaInfo () {
      return {
        title: this.title
      }
  },
  data() {
    return {
      body: "",
      id: "",
      title: ""
    };
  },
  created() {
    const id = this.$route.params.id;
    this.$http
      .get("/api/common/page", {
        params: {
          id: id
        }
      })
      .then(data => {
        if (data) {
          this.body = data.data.body;
          this.title = data.data.title;
          document.title = title + " | MANA";
        }
      });
  }
};
</script>

<style lang="stylus" scoped>
.contents {
  width: 100%;
  background: #fff;

  .content {
    width: 730px;
    margin: 0 auto;
    padding-bottom: 60px;
    font-size: 14px;
    color: rgb(0, 0, 0);

    &>>>p {
      min-height: 20px;
    }
  }

  .title {
    text-align: center;
    font-size: 26px;
    padding: 30px 0;
  }

  [v-cloak] {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/project/PublicAgreement.vue